module.exports = __webpack_public_path__ + "img/image6.87aa6638.svg";